<template>
  <div>
    <div>
      <el-form :inline="true" :model="queryForm" style="text-align:left;" label-width="100px">
        <el-row>
          <el-col :span="7">
            <el-form-item label="综合查询:">
              <el-input v-model="queryForm.name" placeholder="请输入销售员姓名/电话" :clearable="true"></el-input>
            </el-form-item> 
          </el-col>
          <el-col :span="7">
            <el-form-item label="承销商:" class="agent-select">
              <My-Select
                v-model="queryForm.agentCode"
                :objSelect="queryForm.agentCode"
                :options="agentList"
                :placeholder="agentPlaceholder"
                :optionBind="optionBindAgent"
                @changeSelct="changeQueryAgent"
                :clearable="true"
              ></My-Select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="机构:" class="agent-select">
              <My-Select
                v-model="queryForm.agentBranCode"
                :objSelect="queryForm.agentBranCode"
                :placeholder="agentQueryPlaceholder"
                :optionBind="optionBindBran"
                :options="queryAgentBranList"
                @changeSelct="changeQueryAgentBran"
              ></My-Select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="销售人员类型:" class="agent-select">
              <el-select v-model="queryForm.salesLevel" clearable placeholder="请选择销售人员类型">
                <el-option
                    v-for="(item,index) in salesLevelList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item>
              <el-button type="primary" plain @click="query()">查询</el-button>
              <el-button type="primary" plain @click="exportExt()">选中导出</el-button>
              <el-button type="primary" plain @click="exportExtAll()">全部导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div>
      <My-table
        :configurationData="configurationData"
        :operation="operation"
        :getTableParam="getAccountParam"
        :showSwitch="showSwitch"
        :showSpan="showSpan"
        @selection="getMultipleSelection"
        ref="myTable">
      </My-table>
    </div>
    <!-- 总收益 -->
    <el-dialog
      :title="title"
      :visible.sync="totalEditorDialog"
      :close-on-click-modal="false"
      width="1500px"
    >
      <el-divider class="divider-class"></el-divider>
      <el-form
        :model="totalForm"
        :inline="true"
        label-width="100px"
        style="text-align:left">
        <div style="display:flex;justify-content: space-between;">
          <span>销售员级别/姓名:{{tabName}}</span>
          <span>总收益金额:{{tabMoney}}元</span>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="综合查询:" class="agent-input">
              <el-input v-model="totalForm.name" placeholder="请输入延保单号/延保销售单号/用户电话" :clearable="true"></el-input>
            </el-form-item> 
          </el-col>
          <el-col :span="10">
            <el-form-item label="交易日期:" class="datatime-class">
              <el-date-picker
                v-model="totalForm.applyDateStart"
                type="datetime"
                placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <span> - </span>   
              <el-date-picker
                v-model="totalForm.applyDateEnd"
                type="datetime"
                default-time = "23:59:59"
                placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>        
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="延保单状态:" class="state-class">
              <el-select v-model="totalForm.status" clearable>
                <el-option
                  v-for="(item,index) in stateList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" plain @click="queryTotal()">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <My-tab
        :configurationData="childData"
        :operation="operation"
        :getTableParam="getTotalParam"
        ref="myTable1">
      </My-tab>
      <div slot="footer" style="text-align:center">
        <el-button @click="totalEditorDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 待结算 -->
    <el-dialog
      :title="title"
      :visible.sync="noSettledEditorDialog"
      :close-on-click-modal="false"
      width="1500px"
    >
      <el-divider class="divider-class"></el-divider>
      <el-form
        :model="noSettledForm"
        :inline="true"
        label-width="100px"
        style="text-align:left">
        <div style="display:flex;justify-content: space-between;">
          <span>销售员级别/姓名:{{tabName}}</span>
          <span>总待结算金额:{{tabMoney}}元</span>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="综合查询:" class="agent-input">
              <el-input v-model="noSettledForm.name" placeholder="请输入延保单号/延保销售单号/用户电话" :clearable="true"></el-input>
            </el-form-item> 
          </el-col>
          <el-col :span="10">
            <el-form-item label="交易日期:" class="datatime-class">
              <el-date-picker
                  v-model="noSettledForm.applyDateStart"
                  type="datetime"
                  placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <span> - </span>   
              <el-date-picker
                  v-model="noSettledForm.applyDateEnd"
                  type="datetime"
                  default-time = "23:59:59"
                  placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>        
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="延保单状态:" class="state-class">
              <el-select v-model="noSettledForm.status" clearable>
                <el-option
                  v-for="(item,index) in noSettledStatusList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" plain @click="queryNoSettled()">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <My-table
        :configurationData="childData"
        :operation="operation"
        :getTableParam="getNoSettledParam"
        ref="myTable2">
      </My-table>
      <div slot="footer" style="text-align:center">
        <el-button @click="noSettledEditorDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <!-- 已提现 -->
    <el-dialog
      :title="title"
      :visible.sync="finishEditorDialog"
      :close-on-click-modal="false"
      :row-class-name="tableRowClassName"
      width="1500px"
    >
      <el-divider class="divider-class"></el-divider>
      <el-form
        :model="finishForm"
        :inline="true"
        label-width="100px"
        style="text-align:left">
        <div style="display:flex;justify-content: space-between;">
          <span>销售员级别/姓名:{{tabName}}</span>
          <span>总已提现金额:{{tabMoney}}元</span>
        </div>
        <el-row>
          <el-col :span="8">
            <el-form-item label="综合查询:" class="agent-input">
              <el-input v-model="finishForm.name" placeholder="请输入用户电话" :clearable="true"></el-input>
            </el-form-item> 
          </el-col>
          <el-col :span="10">
            <el-form-item label="交易日期:" class="datatime-class">
              <el-date-picker
                  v-model="finishForm.applyDateStart"
                  type="datetime"
                  placeholder="开始时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
              <span> - </span>   
              <el-date-picker
                  v-model="finishForm.applyDateEnd"
                  type="datetime"
                  default-time = "23:59:59"
                  placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>        
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="交易单状态:" class="state-class">
              <el-select v-model="finishForm.status" clearable>
                <el-option
                  v-for="(item,index) in withdrawalList"
                  :key="index"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" plain @click="queryFinish()">查询</el-button>
          </el-col>
        </el-row>
      </el-form>
      <My-table
        :configurationData="withdrawalData"
        :operation="operation"
        :getTableParam="getFinishParam"
        ref="myTable3">
      </My-table>
      <div slot="footer" style="text-align:center">
        <el-button @click="finishEditorDialog = false">关闭</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="延保单详情"
      :visible.sync="extendedPolicyDetailDialog"
      :close-on-click-modal="false"
      width="1200px">
      <el-row style="text-align: left">
        <el-col :span="22">
          <span>单号:{{ this.orderCode }}</span>
        </el-col>
        <el-col :span="2">
          <span>状态:{{ this.stateName }}</span>
        </el-col>
      </el-row>
      <el-divider class="divider-class"></el-divider>
      <el-form
        :inline="true"
        label-width="100px"
        label-suffix=":"
        style="text-align: left;"
      >
        <div v-for="(item, findex) in formList" :key="findex">
          <div
            style="margin-left: 30px;font-weight: bold"
            v-if="item.propertyInfos.length > 0 && item.propertyName != 'syslayer'"
            :class="displayCls(item)">
            {{ item.propertyName }}
          </div>
          <div
            style="padding-left: 30px;"
            v-if="item.propertyInfos.length > 0 && item.propertyName != 'syslayer' ">
            <el-row
              v-for="(item1, index1) in item.propertyInfos"
              :key="index1"
              v-if="index1 % 2 == 0"
            >
              <el-col :span="12">
                <Component-Form
                  :item="getList(item, index1)"
                  :state="stateName"
                ></Component-Form>
              </el-col>
              <el-col :span="12">
                <Component-Form
                  :item="getList(item, index1 + 1)"
                  :state="stateName"
                ></Component-Form>
              </el-col>
            </el-row>
          </div>
        </div>
        <div
          style="margin-left: 30px;font-weight: bold"
          v-if="this.opinionObj != null">
          审核信息
        </div>
        <div style="padding-left: 30px;">
          <el-row>
            <el-col :span="12">
              <el-form-item label="最新审核时间" class="ss-view-item">
                <span>{{ opinionObj.createTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最新审核人员" class="ss-view-item">
                <span>{{ opinionObj.applyUserName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="最新审核原因" class="ss-view-item">
                <span>{{ opinionObj.auditResultsName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="最新审核备注" class="ss-view-item">
                <span>{{ opinionObj.remarks }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div slot="footer" style="display:flex;justify-content:center;padding:30px;">
        <!-- <div v-show="buttonKey.checkButton==true">
          <el-button
            v-show="this.stateName === '待审核'"
            @click="extendedEditor1('approval')"
            >审核</el-button
          >
        </div>
        <div v-show="submitButton==true">
          <el-button
            v-show="this.stateName === '待补充' || this.stateName === '已生效' || this.stateName === '已关闭'"
            @click="submit"
            >提交</el-button
          >
        </div> -->
        
        <div>
          <el-button @click="extendedPolicyDetailDialog = false" style="margin-left:30px;">关闭</el-button>
        </div>
        
      </div>
    </el-dialog>
  </div>
</template>

<script>
import common from "../../../public/static/common";
import  asyncApi   from '../../api/asyncApi';

export default {
  name: "accountManagement",
  data() {
    return {
      title: "",
      stateName: "",
      orderCode: "",
      agentPlaceholder: "请选择承销商名称",
      agentQueryPlaceholder: "请选择机构",
      operationType: "",
      showSwitch: true,
      showSpan: true,
      extendedPolicyDetailDialog: false,
      withdrawalDialog: false,
      queryForm: {},
      agentList: [],
      queryAgentBranList: [],
      multipleSelection: [],
      formList: [],
      detailList: [],
      opinionObj: "",
      salesLevelList:[
        {value:'1',label:'一级销售'},
        {value:'2',label:'二级销售'},
        {value:'3',label:'三级销售'}
      ],  
      stateList: [
        {value: 'FILL',label: '待补充'},
        {value: 'EFFECT',label: '已生效'},
        {value: 'CLOSE',label: '已关闭'}
      ],
      noSettledStatusList:[
        {value: 'CHECK',label: '待审核'},
        {value: 'RESUBMIT',label: '待修改'},
      ],
      optionBindAgent:{
        label:"agentName",
        value:"agentCode"
      },
      optionBindBran: {
        label: "agentBranName",
        value: "agentBranCode",
      },
      // 列表配置
      configurationData: [
        {
          title: "承销商",
          propertys: "agentName",
          width: "",
        },
        {
          title: "机构",
          propertys: "agentBranName",
          width: ""
        },
        {
          title: '销售级别',
          propertys: 'salesLevel',
          width: '',
          format:this.formatLevel
        },
        {
          title: "销售员姓名",
          propertys: "agentSalesName",
          width: ""
        },
        {
          title: "销售员电话",
          propertys: "agentSalesPhone",
          width: "",
        },
        {
          title: "总收益金额",
          propertys: "totalMoney",
          width: "",
          // format:this.formatMoney,
          link: value => this.linkToinfo(value,'totalMoney')
        },
        {
          title: "可提现金额",
          propertys: "withdrawalMoney",
          width: "",
          // format:this.formatMoney
        },
        {
          title: "已提现金额",
          propertys: "finishWithdrawalMoney",
          width: "",
          // format:this.formatMoney,
          link: value => this.linkToinfo(value,'finishWithdrawalMoney')
        },
        {
          title: "待结算金额",
          propertys: "noSettledMoney",
          width: "",
          // format:this.formatMoney,
          link: value => this.linkToinfo(value,'noSettledMoney')
        }
      ],
      childData: [],
      withdrawalData: [
        {
          title: "交易流水号",
          propertys: "withdrawalCode",
          width: ""
        },
        {
          title: "交易单状态",
          propertys: "statusName",
          width: ""
        },
        {
          title: "交易金额/元",
          propertys: "money",
          width: ""
        },
        {
          title: "申请时间",
          propertys: "createTime",
          width: ""
        },
        {
          title: "支付时间",
          propertys: "payTime",
          width: "",
        },
      ],
      withdrawalList: [
        {value: "100",label: '提现审核中'},
        {value: "101",label: '审核通过'},
        {value: "102",label: '审核不通过'},
        {value: "104",label: '提现成功'},
        {value: "105",label: '提现失败'}
      ],
      // 是否有操作按钮 宽度
      operation: {
        show: false,
        width: "",
      },
      getAccountParam: {
        url: "/extwarapi/api/user/accountManagePage",
        param: "",
      },
      // 总收益详情
      getTotalParam: {
        url: '/extwarapi/api/user/totalMoneyList',
        param: ""
      },
      // 已提现
      getFinishParam: {
        url: '/extwarapi/api/user/finishWithdrawalMoneyList',
        param: ""
      },
      // 待结算
      getNoSettledParam: {
        url: '/extwarapi/api/user/noSettledMoneyList',
        param: ""
      },
      // personnelEditorDialog: false,
      totalEditorDialog: false,
      finishEditorDialog: false,
      noSettledEditorDialog: false,

      // editorForm: {},
      totalForm: {},
      finishForm: {},
      noSettledForm: {},

      branchCounter: 0,
      tabName: '',
      tabMoney: ''
    }
  },
  methods: {
    //列表销售级别处理
    formatLevel:function(row){
      if(row.salesLevel=='1'){
          return '一级销售'
      }else if(row.salesLevel=='2'){
          return '二级销售'
      }else if(row.salesLevel=='3'){
          return '三级销售'
      }
    },
    // formatMoney: function(row){
    //   if (row.totalMoney == '0.00'){
    //     return 0
    //   }
    // },
    linkToinfo(row,type) {
      this.totalForm= {}
      this.finishForm= {}
      this.noSettledForm= {}
      if (type === 'totalMoney') {
        this.title = "销售员总收益详情"
        this.childData = [
          {
            title: "交易流水号",
            propertys: "transactionsCode",
            width: ""
          },
          {
            title: "延保单单号",
            propertys: "extensionPolicyId",
            width: "",
            link: value => this.linkToinfo(value,'extensionPolicyId')
          },
          {
            title: "延保单状态",
            propertys: "stateName",
            width: "",
          },
          {
            title: "交易金额/元",
            propertys: "commission",
            width: "",
          },
          {
            title: "延保销售单号",
            propertys: "salesNum",
            width: "",
          },
          {
            title: "交易时间",
            propertys: "checkTime",
            width: "",
          },
        ]
        this.totalEditorDialog = true; // 控制展示
        this.totalForm.userCode = row.userCode
        this.tabName = this.formatLevel(row) + '/' + row.agentSalesName
        this.tabMoney = row.totalMoney
        this.$nextTick(() => {
          this.queryTotal()
        })
      }
      if (type === 'noSettledMoney') {
        this.title = "销售员待结算详情"
        this.childData = [
          {
            title: "延保单单号",
            propertys: "extensionPolicyId",
            width: "",
            link: value => this.linkToinfo(value,'extensionPolicyId')
          },
          {
            title: "延保单状态",
            propertys: "stateName",
            width: "",
          },
          {
            title: "交易金额/元",
            propertys: "money",
            width: "",
          },
          {
            title: "延保销售单号",
            propertys: "salesNum",
            width: "",
          },
          {
            title: "交易时间",
            propertys: "createTime",
            width: "",
          },
        ]
        this.noSettledEditorDialog = true; // 控制展示
        this.noSettledForm.userCode = row.userCode
        this.tabName = this.formatLevel(row) + '/' + row.agentSalesName
        this.tabMoney = row.noSettledMoney
        this.$nextTick(() => {
          this.queryNoSettled()
        })
      }
      if (type === 'finishWithdrawalMoney') {
        this.title = "销售员已提现详情"
        this.finishEditorDialog = true; // 控制展示
        this.finishForm.userCode = row.userCode
        this.tabName = this.formatLevel(row) + '/' + row.agentSalesName
        this.tabMoney = row.finishWithdrawalMoney
        this.$nextTick(() => {
          this.queryFinish()
        })
      }
      if (type === 'extensionPolicyId') {
        this.orderCode = row.extensionPolicyId;
        this.stateName = row.stateName;
        this.extendedPolicyDetailDialog = true
        this.$nextTick(() => {
          this.getDetail(row);
        })
      }
    },
    getList(item, index) {
      return item.propertyInfos[index];
    },
    // 提现失败状态
    tableRowClassName({row,rowIndex}) {
      console.log('table',row)
      if (row.statusName == '审核不通过' || row.statusName == "提现失败") {
        return 'error-row'
      }
    },
    async getDetail(row) {
      let me = this;
      let url = "/extwarapi/api/extensionPolicy/formDetail";
      let formCode = "100";
      if (row.formCode) {
        formCode = row.formCode;
      }
      let param = {
        orderCode: row.extensionPolicyId,
        currentUser: common.getCurrUser().userCode,
        formCode: formCode,
        nodeCode: "500",
      };
      // 1、判断用户是否有修改，审核权限（根据权限在详情中判断显隐）
      // 2、根据用户下权限调用不同的nodecode
      await asyncApi.post(url, param).then((resp) => {
        if (resp.code == "0000") {
          me.opinionObj = "";
          if (resp.result.opinion != null) {
            if (resp.result.opinion.reason && resp.result.opinion.reason != "") {
              resp.result.opinion.auditResultsName = resp.result.opinion.reason;
            }
            me.opinionObj = resp.result.opinion;
          }
          me.formList = resp.result.propertyInfos;
          me.detailList = resp.result;
          me.buildSpecialProperty(this.formList);
        }
      }).catch((resp) => {
        console.log("error", resp);
      })
    },
    buildSpecialProperty: function(propertyInfos) {
      //条码 //依赖于产品的data[i].barcode;
      let prodProp = this.findPropByAlias(propertyInfos, "prod");
      if (prodProp && prodProp.propertyValue) {
        this.buildBarcodeProperty(propertyInfos, prodProp);
      }
    },
    buildBarcodeProperty: function(propertyInfos, prodProp) {
      let prodData = prodProp.data;
      let bar1Prop = this.findPropByAlias(propertyInfos, "barCode1");
      let bar2Prop = this.findPropByAlias(propertyInfos, "barCode2");
      let prodBarVal = "";
      let prodVal = prodProp.propertyValue;
      if (prodData) {
        for (let i = 0; i < prodData.length; i++) {
          let pdata = prodData[i];
          if ((pdata.code = prodVal)) {
            prodBarVal = pdata.barCode;
            break;
          }
        }
      }

      if (prodBarVal == "0" || prodBarVal == "") {
        bar1Prop.phidclass = "ss-hid";
        bar2Prop.phidclass = "ss-hid";
      } else if (prodBarVal == "1" || prodBarVal == "3") {
        bar1Prop.phidclass = "";
        bar2Prop.phidclass = "ss-hid";
      } else if (prodBarVal == "2") {
        bar1Prop.phidclass = "";
        bar2Prop.phidclass = "";
      }
    },
    findPropByAlias: function(propertyInfos, alias) {
      if (propertyInfos) {
        for (let i = 0; i < propertyInfos.length; i++) {
          let props = propertyInfos[i].propertyInfos;
          if (props) {
            for (let j = 0; j < props.length; j++) {
              let prop = props[j];
              if (prop.alias && prop.alias == alias) {
                return prop;
              }
            }
          }
        }
      }
      return null;
    },
    displayCls: function(prop) {
      let isshow = false;
      if (prop.propertyInfos) {
        for (let i = 0; i < prop.propertyInfos.length; i++) {
          let item = prop.propertyInfos[i];
          if (item.phidclass && item.phidclass.length > 0) {
          } else {
            isshow = true;
            break;
          }
        }
      }
      let cls = "";
      if (!isshow) {
        cls = "ss-hid";
      }
      return cls;
    },
    query() {
      console.log('query1')
      this.getAccountParam.param = this.queryForm;
      this.$refs["myTable"].query(1);
      // this.queryForm = {}
    },
    queryTotal(){
      console.log('query2')
      this.getTotalParam.param = this.totalForm
      this.$refs["myTable1"].query(1)
    },
    queryFinish(){
      console.log('query3')
      this.getFinishParam.param = this.finishForm
      this.$refs["myTable3"].query(1)
    },
    queryNoSettled(){
      console.log('query4')
      this.getNoSettledParam.param = this.noSettledForm
      this.$refs["myTable2"].query(1)
    },
    getMultipleSelection(data) {
      // console.log('multi',data)
      this.multipleSelection = []
      for(let i in data){
        this.multipleSelection.push(data[i].id)
      }
    },
    // 导出 
    exportExt() {
      if(this.multipleSelection.length === 0){
        this.$message({
          message: '请至少勾选一项，再进行操作',
          type: 'warning'
        })
      }else{
        this.queryForm.idList=[]
        for(var i=0;i<this.multipleSelection.length;i++){
          this.queryForm.idList.push(this.multipleSelection[i])
        }
        let url="/extwarapi/api/user/accountManagePageExport";
        let param=Object.assign({},this.queryForm);
            param.pageNum=1;
            param.pageSize=9999;
        this.axios.post(url, param,{responseType: "blob"}).then((resp) => {
          // console.log('resp',resp)
          let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
          let blob = new Blob([resp.data], { type: ".xlsx" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob,fileName);
          } else {
            let a = document.createElement("a");
            a.download = fileName;
            a.href = window.URL.createObjectURL(blob);
            a.click();
            // 清除选中状态
            // if(this.idList.idList){
              setTimeout(()=>{
                this.$refs.myTable.clear()
                this.queryForm.idList = []
              },1500)
            // }
            //释放内存
              window.URL.revokeObjectURL(a.href)
          }
        }).catch((resp) => {
          console.log('error', resp);
        })
      }
    },
    exportExtAll() {
      let url="/extwarapi/api/user/accountManagePageExport";
      let param=Object.assign({},this.queryForm);
          param.pageNum=1;
          param.pageSize=9999;
      if(common.getCurrUserRoleList()[0].roleCode!='admin'){
        param.agentCode = common.getCurrUser().agentCode
      }
      this.axios.post(url, param,{responseType: "blob"}).then((resp) => {
        let fileName=decodeURIComponent(resp.headers["content-disposition"]).split('=')[1];
        let blob = new Blob([resp.data], { type: ".xlsx" });
        if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob,fileName);
        } else {
          let a = document.createElement("a");
          a.download = fileName;
          a.href = window.URL.createObjectURL(blob);
          a.click();
          //释放内存
          window.URL.revokeObjectURL(a.href)
        }
      }).catch((resp) => {
        console.log('error', resp)
      })
    },
    //获取承销商数据字典
    async getAgentList(){
      let url ="/extwarapi/api/agent/getAgentEnum";
      let data = await asyncApi.post(url,null);
      if(data.code=='0000'){
        this.agentList=data.result;
      }
    },
    //获取机构字典
    async getAgentBranList() {
      let url = "/extwarapi/api/agent/getAgentBranchEnum";
      let code = {"code": ''}
      this.axios.post(url, code).then((resp) => {
        if (resp.data.code == "0000") {
          this.queryAgentBranList = resp.data.result
        }
      })
      .catch((resp) => {
        console.log("error", resp);
      });
    },
    // 承销商选择
    changeQueryAgent(value) {
      this.queryForm.agentCode = value
    },
    // 机构选择
    changeQueryAgentBran(value) {
      this.queryForm.agentBranCode = value;
    },
    // 延保单状态
    // changeState(value) {
    //   console.log('value-11',value)
    //   this.editorForm.state = value
    // },
    // changeWithdrawalState(value) {
    //   this.editorForm.withdrawalState = value
    // },
    // resetForm(formName) {
    //   console.log('formName',formName)
    //   this.personnelEditorDialog = false;
    //   this.$refs[formName].resetFields();
    // }
  },
  mounted() {
    // this.getUnderwriterList();
    this.getAgentList();
    this.getAgentBranList()
  },
};
</script>
<style lang="scss">
.el-table .error-row {
  background: #FF0000;
}
.agent-input .el-input__inner {
  width: 300px;
}
.state-class .el-input--suffix {
  width: 100px;
}
.datatime-class .el-date-editor {
  width: 200px;
}
.phone-input .el-input {
  width: 300px;
}
</style>
